import { render, staticRenderFns } from "./RightFiexd.vue?vue&type=template&id=75c230da&scoped=true&"
import script from "./RightFiexd.vue?vue&type=script&lang=js&"
export * from "./RightFiexd.vue?vue&type=script&lang=js&"
import style0 from "./RightFiexd.vue?vue&type=style&index=0&id=75c230da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c230da",
  null
  
)

export default component.exports